var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "md": _vm.md,
      "isDone": _vm.isValid,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "debug": [_vm.isWrapped, _vm.isWrapDamaged]
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": ""
    },
    model: {
      value: _vm.isWrapped,
      callback: function callback($$v) {
        _vm.isWrapped = $$v;
      },
      expression: "isWrapped"
    }
  }, [_c('v-card', {
    staticClass: "pa-2 pt-4 my-2",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "value": false
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('strong', [_vm._v(_vm._s(_vm.$t("report.ReportWrapping.isWrappedFalse")))])];
      },
      proxy: true
    }])
  }), _c('v-card-text', {
    staticClass: "ml-4"
  }, [_vm._v(_vm._s(_vm.$t("report.ReportWrapping.isWrappedFalseDescription")))])], 1), _c('v-card', {
    staticClass: "pa-2 pt-4 my-2",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "value": true
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('strong', [_vm._v(_vm._s(_vm.$t("report.ReportWrapping.isWrappedTrue")))])];
      },
      proxy: true
    }])
  }), _c('v-card-text', {
    staticClass: "ml-4"
  }, [_vm._v(_vm._s(_vm.$t("report.ReportWrapping.isWrappedTrueDescription")) + " "), _vm.isWrapped ? _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('objects.report.isWrapDamaged'),
      "data-test-whatsapp-checkbox": ""
    },
    model: {
      value: _vm.isWrapDamaged,
      callback: function callback($$v) {
        _vm.isWrapDamaged = $$v;
      },
      expression: "isWrapDamaged"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }